import clsx from 'clsx'
import React from 'react'
import Image from '@/components/Image'

interface Props {
  className?: string
  loading?: 'lazy' | 'eager'
  priority?: 'auto' | 'high' | 'low'
}

export const Logo = (props: Props) => {
  const { loading: loadingFromProps, priority: priorityFromProps, className } = props

  const loading = loadingFromProps || 'lazy'
  const priority = priorityFromProps || 'low'

  return (
    <Image
      alt="JeugdFilms Logo"
      loading={loading}
      fetchPriority={priority}
      decoding="async"
      width={74}
      height={40}
      className={clsx(className)}
      src="/media/logo.png"
    />
  )
}
